// AsideModuleHint.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { color } from '../style/variables.js';

export const AsideModuleHint = () => {
  const { t } = useTranslation();

  return (
    <StyledAsideModuleHint>
      {t('livestream_toy_interactive_module_upgrade_hint', {
        ns: TranslationNamespace.LIVESTREAM,
      })}
    </StyledAsideModuleHint>
  );
};

AsideModuleHint.propTypes = {};

const StyledAsideModuleHint = styled.div`
  position: absolute;
  top: 25%;
  right: 16px;
  transform: translateY(-50%);
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: ${color.neutral[100]};
  background-color: ${color.neutral[0]};
  text-align: center;
  display: inline-block;
  width: max-content;
  max-width: 250px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  box-shadow: 0px 2px 8px 0px rgba(25, 25, 25, 0.2);
  z-index: 2;

  &::after {
    position: absolute;
    top: 50%;
    right: -4px;
    width: 8px;
    height: 8px;
    background-color: ${color.neutral[0]};
    transform: translateY(-50%) rotate(45deg);
    content: '';
  }
`;

export default AsideModuleHint;
